// extracted by mini-css-extract-plugin
export default {"link":"UQ-z","disabled":"VQ-z"};